module.exports = __webpack_public_path__ + "b0daebfbf40a3a62d684ada63a7b93.png";